import React, { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../../common/components/Button";
import {
  deleteDailySchedule,
  getAllDailySchedule,
} from "../../../../api/scheduleApi";
import AddDailyScheduleDialog from "./AddDailyScheduleDialog";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateDailyScheduleDialog from "./UpdateDailyScheduleDialog";
import { getTime } from "../../../../common/helpers/normalizeDateTime";
import ConfirmationDialog from "../../../../common/components/Dialog";
const DailyScheduleTable = ({
  theme,
  handleOpenAlert,
  handleSetAlertMessage,
}) => {
  const [openAddDailySchedule, setOpenAddDailySchedule] = useState(false);
  const [openUpdateDailySchedule, setOpenUpdatelignerMaterial] =
    useState(false);

  const [rows, setRows] = useState([]);
  const [currentDailySchedule, setCurrentDailySchedule] = useState({});
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  useEffect(() => {
    fetchDailySchedule();
  }, []);

  const fetchDailySchedule = async () => {
    const response = await getAllDailySchedule();
    setRows(response.data.data);
  };

  const handleDeleteDailySchedule = async (id) => {
    await deleteDailySchedule(id);
    await fetchDailySchedule();
  };

  const handleOpenAddDailySchedule = () => {
    setOpenAddDailySchedule(true);
  };

  const handleCloseAddDailySchedule = () => {
    setOpenAddDailySchedule(false);
  };
  //Update
  const handleOpenUpdateDailySchedule = (event, params) => {
    event.stopPropagation();
    setCurrentDailySchedule({ ...params.row });
    setOpenUpdatelignerMaterial(true);
  };
  const handleCloseUpdateDailySchedule = () => {
    setOpenUpdatelignerMaterial(false);
  };

  const columns = [
    { field: "day", headerName: "Day", flex: 1 },
    {
      field: "startTime",
      headerName: "Start Time",
      flex: 1,
      valueFormatter: (params) =>
        params?.value !== null ? getTime(params?.value) : "",
    },

    {
      field: "endTime",
      headerName: "End Time",
      flex: 1,
      valueFormatter: (params) =>
        params?.value !== null ? getTime(params?.value) : "",
    },
    {
      field: "timeSlotDurationMins",
      headerName: "Time Slot Duration (in minutes)",
      flex: 1,
    },

    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <GridActionsCellItem
              icon={<FontAwesomeIcon icon={faPen} />}
              label="Update"
              onClick={(e) => handleOpenUpdateDailySchedule(e, params)}
            />
            <GridActionsCellItem
              icon={<FontAwesomeIcon icon={faTrash} />}
              label="Delete"
              onClick={(e) => {
                e.stopPropagation();
                setShowConfirmationDialog(true);
                setConfirmationSubmit(() => () => {
                  handleDeleteDailySchedule(params.id);
                  setShowConfirmationDialog(false);
                });
              }}
            />
          </>
        );
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Daily Schedule</StyledH2>
      <StyledButton onClick={handleOpenAddDailySchedule} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add Daily Schedule
      </StyledButton>

      <AddDailyScheduleDialog
        openAddDailySchedule={openAddDailySchedule}
        handleCloseAddDailySchedule={handleCloseAddDailySchedule}
        currentDailySchedule={currentDailySchedule}
        fetchDailySchedule={fetchDailySchedule}
        handleOpenAlert={handleOpenAlert}
        handleSetAlertMessage={handleSetAlertMessage}
      />
      <UpdateDailyScheduleDialog
        openUpdateDailySchedule={openUpdateDailySchedule}
        handleCloseUpdateDailySchedule={handleCloseUpdateDailySchedule}
        currentDailySchedule={currentDailySchedule}
        fetchDailySchedule={fetchDailySchedule}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete daily schedule?"}
      />

      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default DailyScheduleTable;
